import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import TermsPage from './pages/TermsPage';
import GdprPage from './pages/GdprPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-[var(--vp-paper)]">
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              fontFamily: 'var(--font-body)',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/op" element={<TermsPage />} />
          <Route path="/gdpr" element={<GdprPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
